import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { XmarkIcon } from '@dynatrace/strato-icons';

import { Button } from '../../buttons/button/Button.js';
import * as baseInputStyles from './BaseInput.sty.js';
import { BaseInputContext } from './contexts/BaseInputContext.js';

/**
 * Renders the built-in clear button for inputs.
 * It inherits its error and disabled state from the surrounding `BaseInputContext`.
 */
export const ClearButton = ({ onClear }: { onClear: VoidFunction }) => {
  const intl = useIntl();
  const { hasError, disabled, ariaDisabled } = useContext(BaseInputContext);
  const disabledOrAriaDisabled = disabled || ariaDisabled || false;

  return (
    <Button
      onClick={onClear}
      className={baseInputStyles.reservedSuffixButton}
      color={hasError ? 'critical' : 'neutral'}
      disabled={disabledOrAriaDisabled}
      aria-label={intl.formatMessage({
        id: 'MY7AZtZAiZ2+M5X3',
        defaultMessage: 'Clear text',
        description: 'Label for the clear button of an input field.',
      })}
      data-dt-children-name="ClearAll"
    >
      <XmarkIcon />
    </Button>
  );
};
